import i18n from '../i18n';
import { isVideo } from '../utils/files';
import { ContentOutline } from './ContentOutline';
import { CourseSection } from './CourseSection';
import { Edition } from './Edition';
import { Item } from './Item';
import {
  Transcript,
  translateTranscriptForTransport,
  translateTranscriptFromTransport,
} from './Transcript';
import { TranscriptionJob } from './TranscriptionJob';

export interface Content extends Item {
  name: string;
  url: string;
  mimeType: string;

  editionId?: number;
  edition?: Edition;

  imagePath?: string;

  courseSectionId?: number;
  courseSection?: CourseSection;

  contentLength: number;

  originalFileName?: string;

  transcriptId?: number;
  transcript?: Transcript;

  transcriptionJobs?: TranscriptionJob[];

  canAssess?: boolean;

  coverImageUrl?: string;

  contentOutlineId?: number;
  contentOutline?: ContentOutline;

  showTranscript?: boolean;
  showSummaries?: boolean;
  key?: string;
}

export const displayContentMimeType = (mimeType: string): string => {
  switch (mimeType) {
    case 'video/3gpp':
    case 'video/mpeg':
    case 'video/quicktime':
    case 'video/mp4':
      return i18n.t('video');
    case 'image/png':
    case 'image/jpg':
    case 'image/jpeg':
      return i18n.t('image');
    case 'application/epub+zip':
      return i18n.t('eBook');
    case 'application/pdf':
      return i18n.t('pdfDocument');
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return i18n.t('powerpoint');
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return i18n.t('wordDocument');
    default:
      return i18n.t('unknown');
  }
};

export const translateContentFromTransport = (attributes: any): any => {
  if (!attributes) {
    return attributes;
  }

  const { transcript } = attributes;
  if (!transcript) {
    return attributes;
  }

  return {
    ...attributes,
    transcript: translateTranscriptFromTransport(transcript),
  };
};

export const translateContentForTransport = (attributes: any): any => {
  if (!attributes) {
    return attributes;
  }

  const { transcript } = attributes;
  if (!transcript) {
    return attributes;
  }

  return {
    ...attributes,
    transcript: translateTranscriptForTransport(transcript),
  };
};

export const isDocumentContent = (content?: Content): boolean => {
  const mimeTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ];

  return content?.mimeType ? mimeTypes.includes(content?.mimeType) : false;
};

export const isVideoContent = (content?: Content): boolean => {
  return content?.mimeType ? isVideo(content.mimeType) : false;
};

export const isContent = (content?: any): boolean => {
  return content?.contentOutlineId ? true : false;
};
